<div class="warehouse-dashboard-v2">
  <h3 class="dashboard-title">Warehouse Dashboard</h3>

  <!-- Dropdown Row -->
  <div class="dashboard-filters-row">
    <div class="dropdown-card">
      <label for="warehouseSelect" class="form-label">Warehouse</label>
      <select id="warehouseSelect" class="form-select dropdown-compact" [(ngModel)]="selectedWarehouseId" (change)="onWarehouseChange()">
        <option *ngFor="let wh of warehouses" [value]="wh.id">{{ wh.name }}</option>
      </select>
    </div>
  </div>

  <!-- Metric Summary Row -->
  <div class="dashboard-metrics" style="margin-bottom:1.5rem;">
    <div class="metric-box" role="button" tabindex="0" (click)="navigateToCard('active')" [ngStyle]="{'--accent': '#24b946'}">
      <div class="metric-content">
        <div class="metric-icon"><i class="fa fa-check-circle" aria-hidden="true"></i></div>
        <div class="metric-count">{{ activeStocks }}</div>
        <div class="metric-bottom">
          <div class="metric-label">Active Implants</div>
          <div class="metric-trend">
            <span class="trend-text">+5%</span>
            <span class="trend-icon">↗</span>
          </div>
        </div>
      </div>
    </div>
    <div class="metric-box" role="button" tabindex="0" (click)="navigateToCard('expiring')" [ngStyle]="{'--accent': '#e67e22'}">
      <div class="metric-content">
        <div class="metric-icon"><i class="fa fa-hourglass-half" aria-hidden="true"></i></div>
        <div class="metric-count">{{ expiringStocks }}</div>
        <div class="metric-bottom">
          <div class="metric-label">Expiring Implants</div>
          <div class="metric-trend">
            <span class="trend-text">-2%</span>
            <span class="trend-icon">↘</span>
          </div>
        </div>
      </div>
    </div>
    <div class="metric-box" role="button" tabindex="0" (click)="navigateToCard('expired')" [ngStyle]="{'--accent': '#e74c3c'}">
      <div class="metric-content">
        <div class="metric-icon"><i class="fa fa-clock-o" aria-hidden="true"></i></div>
        <div class="metric-count">{{ expiredStocks }}</div>
        <div class="metric-bottom">
          <div class="metric-label">Expired Implants</div>
          <div class="metric-trend">
            <span class="trend-text">0%</span>
            <span class="trend-icon">→</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Charts Grid -->
  <div class="dashboard-charts-grid">
    <div class="dashboard-chart-cell">
      <div class="chart-title">Shipment Summary</div>
      <canvas #shipmentSummaryChart></canvas>
    </div>
    <div class="dashboard-chart-cell">
      <div class="dashboard-card">
        <div class="card-header">
          <h4 class="card-title">Category-wise Stocks</h4>
        </div>
        <div class="card-content">
          <div *ngIf="!categoryStocksData || !categoryStocksData.labels || categoryStocksData.labels.length === 0" class="empty-state-message">
            <i class="fa fa-pie-chart empty-icon" aria-hidden="true"></i>
            <span>No category stock data available for the selected warehouse.</span>
          </div>
          <canvas #categoryStocksChart class="chart-canvas" [style.display]="!categoryStocksData || !categoryStocksData.labels || categoryStocksData.labels.length === 0 ? 'none' : 'block'"></canvas>
        </div>
      </div>
    </div>
  </div>
</div> 